<template>
    <div class="bestandHolder">
        <router-view></router-view>
        <div class="bestandTop">
            Sortierung:
            <select class="bestandSortSelect" v-model="bestandSort">
                <option value="artNum">artnum</option>
                <option value="shorttxt">bezeichnung</option>
                <option value="lagerOrt">lagerort</option>
            </select>
            Filter:
            <select class="bestandSortSelect" v-model="bestandFilt">
                <option value="none">-none-</option>
                <option value="mhd">MHD</option>
            </select>
        </div>
        <div class="bestanditemHolder">

            <table class="bestandTable">
                <tr>
                    <th class="bestandHeadCells">SBB Art. Nummer</th>
                    <th class="bestandHeadCells">SAP-Bezeichnung</th>
                    <th class="bestandHeadCells">Lagerort</th>
                    <th class="bestandHeadCells">bestand</th>
                    <th class="bestandHeadCells">Me-Einheit</th>
                </tr>
                <tr v-for="item in artBestand"
                    :key="item.id"
                    class="bestandItem"
                >
                    <td class="bestandCells" @click="openArtInfo(item.id)">{{item.artnum}}</td>
                    <td class="bestandCells" @click="openArtInfo(item.id)">{{item.shorttxt}}</td>
                    <td class="bestandCells" @click="openArtInfo(item.id)">{{item.lagerOrt}}</td>
                    <td class="bestandCells" @click="openArtInfo(item.id)">{{item.besMax}}</td>
                    <td class="bestandCells" @click="openArtInfo(item.id)">{{item.mengeneinheit}}</td>
                </tr>
            </table>

            <!-- <div v-for="item in artBestand" class="bestandItem">
                <div class="bestandItemTextHolder" @click="openArtInfo(item.id)">
                    <p>{{item.artnum}}</p>
                    <p>{{item.shorttxt}}</p>
                    <p>bestand: {{item.besMax}}</p>
                </div>
                <button class="bestandPrintButton">print</button> -->
            <!-- </div>  -->
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            bestandSort: 'artNum',
            bestandFilt: 'none'
        }
    },
    props: {
        stao: {
            type: String,
            default: '1'
        }
    },
    computed: {
        artBestand() {
            return this.$store.getters['lager/bestand'];
        }
    },
    watch: {
        bestandSort() {
            this.$store.dispatch('lager/bestand', { stao: this.stao, sort: this.bestandSort, filt: this.bestandFilt });
        },

        bestandFilt() {
            this.$store.dispatch('lager/bestand', { stao: this.stao, sort: this.bestandSort, filt: this.bestandFilt });
        }

    },
    methods: {
        openArtInfo(id) {
            this.$router.push(this.stao + '/artdetails/' + id + '/');
        }

    },
    beforeDestroy() {
    },
    created() {
        this.$store.dispatch('lager/bestand', { stao: this.stao, sort: this.bestandSort });
    }
}
</script>http://localhost:8080/fotodatenbank/search/g

<style scoped lang="scss">

    .bestandHolder {
        position: absolute;
        width: 100%;
        height: 100vh;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
    }

    .bestandTop {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 80px;
        background-color: $color-white;
        font-size: 2rem;
    }

    .bestandTable {
        border-collapse: collapse;
        margin-left: 1.25rem;
        font-size: 1.25rem;
    }

    .bestandHeadCells {
        padding: 0.625rem;
    }

    .bestandItem {
        font-size: 1.25rem;
        border: none;
        padding: 0.375rem;
        cursor: pointer;
        height: 2.5rem;
    }

    .bestandItem:hover {
        background-color: $color-gray;
    }

    .bestandItem:active {
        background-color: $color-green;
    }

    .bestandCells {
        border: none;
        padding: 0.625rem;
        text-align: center;
    }

    .bestandSortSelect {
        height: 3rem;
        font-size: 2rem;
    }

    .bestanditemHolder {
        display: flex;
        flex-direction: column;
        background-color: $color-white;
        width: 100%;
        height: 100%;
        overflow: scroll;
    }

    /*.bestandItem{
        display:flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0.375rem;
        cursor: pointer;
        border-bottom: 0.125rem solid black;
    }*/

    .bestandItemTextHolder {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .bestandItemTextHolder:hover {
        background-color: $color-gray;
    }

    .bestandItemTextHolder:active {
        background-color: $color-green;
    }

    .bestandPrintButton {
        height: 100%;

    }

    @include medium {

    }

    @include extra-large {

    }

</style>
